import { render, staticRenderFns } from "./AnnotationForm.vue?vue&type=template&id=75139b3a&"
import script from "./AnnotationForm.vue?vue&type=script&lang=js&"
export * from "./AnnotationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports